export default __webpack_public_path__ + "static/media/inst-icon.5377a69a.svg";